<template>
  
<div class="wardrobes" v-if="builder.quote.adjusters && builder.quote.adjusters.length && builder.quote.valid">
    
  <div class="wardrobe">
    <div class="wardrobe-inner">
      
      <div class="wardrobe-main l_p0 l_wrap">
        
        <div class="wardrobe-cost l_lineitem" v-for="adjuster in builder.quote.adjusters">
          <div class="wardrobe-cost-label" v-html="adjuster.formattedTitle"></div>
          <div class="wardrobe-cost-price" v-html="builder.displayPriceIncludeGst(adjuster.calcTotal)"></div>
        </div>
      
      </div>
      
    </div>
  </div>

</div>

</template>

<script setup>

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

</script>